import { Theme } from "../enums";

export const ThemeReverseMap = {
  [Theme.Dark]: Theme.Light,
  [Theme.Light]: Theme.Dark,
};
